import { useState } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import classes from './pozitivnaLinija.module.css'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'
import runCalculator from '../api/runCalculator'

const calculatorType = 'Pozitivna linija'

const PozitivnaLinija = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState('')
  const [series, setSeries] = useState([{ id: 1 }])

  const [data, setData] = useState({
    values: {
      serie1: {
        stake: '',
        odds: '',
        hasPassed: '',
        percentage: '',
        missOdds: '',
      },
    },
    result: {
      serie1Results: ['-', '-', '-', '-', '-', '-'],
    },
  })

  const clearFields = () => {
    setData((prevData) => {
      const clearedValues = {}
      const clearedResults = {}

      Object.keys(prevData.values).forEach((key) => {
        clearedValues[key] = {
          stake: '',
          odds: '',
          hasPassed: '',
          percentage: '',
          missOdds: '',
        }
      })

      Object.keys(prevData.result).forEach((key) => {
        clearedResults[key] = ['-', '-', '-', '-', '-', '-']
      })

      return {
        values: clearedValues,
        result: clearedResults,
      }
    })

    setApiError('')
    setSeries([{ id: 1 }])
  }

  const buildBody = () => {
    const seriesKeys = Object.keys(data.values)

    return {
      initialStake: parseFloat(data.values.serie1.stake) || 0,
      oddsList: seriesKeys.map((key) => parseFloat(data.values[key].odds)),
      outcomes: seriesKeys.map((key) =>
        (data.values[key].hasPassed || '').toLowerCase()
      ),
      carryForwardPercentages: seriesKeys.map((key) =>
        parseFloat(data.values[key].percentage)
      ),
    }
  }

  const handleCalculate = async () => {
    setLoading(true)
    setApiError('')

    try {
      const result = await runCalculator(
        'progressions',
        'positive-line',
        buildBody()
      )

      setData((prevData) => {
        const newResults = {}
        const newValues = { ...prevData.values }
        const seriesKeys = Object.keys(prevData.values)

        seriesKeys.forEach((serieKey, index) => {
          const row = result.rows[index]
          if (!row) return

          newResults[`${serieKey}Results`] = [
            row.potentialWin.toString(),
            row.netProfit.toString(),
            row.carryForwardUnits.toString(),
            row.adjustedStake.toString(),
            row.netProfit.toString(),
            row.missStakeStatus,
          ]

          const nextKey = seriesKeys[index + 1]
          if (nextKey) {
            newValues[nextKey] = {
              ...newValues[nextKey],
              stake: Math.abs(row.carryForwardUnits).toString(),
            }
          }
        })

        return {
          ...prevData,
          values: {
            ...newValues,
          },
          result: {
            ...prevData.result,
            ...newResults,
          },
        }
      })
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      const newKey = `serie${newSeries.length}`

      setData((prevData) => ({
        ...prevData,
        values: {
          ...prevData.values,
          [newKey]: {
            stake: '',
            odds: '',
            hasPassed: '',
            percentage: '',
            missOdds: '',
          },
        },
        result: {
          ...prevData.result,
          [`${newKey}Results`]: ['-', '-', '-', '-', '-', '-'],
        },
      }))

      return newSeries
    })
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleCalculate} disabled={loading}>
            {loading ? 'Obračun u toku...' : 'Prikaži rezultate'}
          </button>
        </div>
        {apiError && (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '8px' }}>
            {apiError}
          </div>
        )}
        {showInputArea && (
          <div className={classesK.sectionContainer}>
            <div className={classesK.sectionTitle}>Igra</div>
            <div
              className={`${classesK.oddsContainer} ${classes.pozitivnaLinijaCalc}`}
            >
              <span>Upiši ulog</span>
              <input
                type='number'
                step='1'
                min='1'
                value={data.values.serie1.stake[0]}
                onChange={(e) => {
                  const value = parseFloat(e.target.value)
                  setData((prevData) => ({
                    ...prevData,
                    values: {
                      ...prevData.values,
                      serie1: {
                        ...prevData.values.serie1,
                        stake: value,
                      },
                    },
                  }))
                }}
                className={classes.oddsInput}
              />
            </div>

            {series.map((series) => {
              const serieKey = `serie${series.id}`
              return (
                <div key={series.id} className={classes.seriesContainer}>
                  <div className={classes.seriesTitle}>
                    Serija br. {series.id}
                  </div>
                  <div className={classes.seriesValues}>
                    <div className={classes.wrapper}>
                      {series.id > 1 && (
                        <ResultsSection
                          names={['Ulog']}
                          results={[data.values[serieKey].stake]}
                          allowNegative={true}
                        />
                      )}

                      <div className={classesK.oddsContainer}>
                        <span>Upiši kvotu</span>
                        <input
                          type='number'
                          value={data.values[serieKey].odds}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  odds: value,
                                },
                              },
                            }))
                          }}
                          step='0.1'
                          min='0.1'
                        />
                      </div>
                    </div>

                    <div className={classes.wrapper}>
                      <div className={classesK.oddsContainer}>
                        <span>Upiši prolaz ( Da / Ne )</span>
                        <input
                          type='text'
                          value={data.values[serieKey].hasPassed}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  hasPassed: value,
                                },
                              },
                            }))
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>

                      <div className={classesK.oddsContainer}>
                        <span>Upiši procenat ( prenos u sledeći krug )</span>
                        <input
                          type='number'
                          value={data.values[serieKey].percentage}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  percentage: value,
                                },
                              },
                            }))
                          }}
                          step='1'
                          min='1'
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    <div className={classes.wrapper}>
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][0]]}
                        names={['Potencijalni dobitak']}
                        allowNegative={true}
                      />
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][1]]}
                        names={['Čista dobit']}
                        allowNegative={true}
                      />
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][2]]}
                        names={['Prenos u unitima']}
                        allowNegative={true}
                      />
                    </div>

                    <div className={classes.wrapper}>
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][3]]}
                        names={['Trenutno stanje']}
                        allowNegative={true}
                      />

                      <div className={classesK.oddsContainer}>
                        <span>Upiši ulog promašaja</span>
                        <input
                          type='number'
                          value={data.values[serieKey].missOdds}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  missOdds: value,
                                },
                              },
                            }))
                          }}
                          step='1'
                          min='1'
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}

            {series.length < 25 && (
              <div style={{ marginTop: '5px' }} className={classesK.addMore}>
                <button onClick={addSeries} className={classesK.addButton}>
                  <img src={add} height={18} width={18} alt='image' />
                  Dodaj još jednu seriju
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default PozitivnaLinija
